import React, { useEffect } from "react";
import { ChatFooter } from "./ConversationFooters";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import TeamChatConversations from "../../team_chat/widget/TeamChatConversations";
import DepartmentChatConversations from "../../department_chat/widget/DepartmentChatConversations";
import GroupChatConversations from "../../group_chat/widget/GroupChatConversations";
import { DepartmentChatsContextImport } from "../../../../provider/chats/chats/department_chats/DepartmentChatsContextProvider";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const ConversationContent = () => {
  const type: number = ResponsiveDeviceType();

  const { chatSelected, getSelectedChatSession } = ChatsContextImport();
  const { conversationDetail } = DepartmentChatsContextImport();

  const defaultMessageStatus: boolean =
    chatSelected !== null &&
    chatSelected?.flag === "2" &&
    conversationDetail != null &&
    conversationDetail?.default_message_status === "1" &&
    UtilityHelper.isNotEmpty(conversationDetail?.default_message!)
      ? true
      : false;

  useEffect(() => {
    if (type !== 3) {
      getSelectedChatSession();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div
      className={`chat-conversation-wrap ${
        defaultMessageStatus ? "welcome-default-message" : ""
      } `}
    >
      {chatSelected == null ? (
        <Center>{Loader.normal()}</Center>
      ) : ["1", "4"].includes(chatSelected?.flag!) ? (
        <TeamChatConversations />
      ) : chatSelected?.flag! === "2" ? (
        <DepartmentChatConversations />
      ) : chatSelected?.flag! === "3" ? (
        <GroupChatConversations />
      ) : (
        <></>
      )}
      <ChatFooter />
    </div>
  );
};

export default ConversationContent;
